import(/* webpackMode: "eager" */ "/home/jenkins/workspace/ecs-x86-xlarge-ecs-x86-xlarge-k8r2l/workspace/lier_Network_csn-venue-mono_main/packages/venue-search-app/app/src/app/global-error.tsx");
